import React from 'react';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import { ICastingDirector } from '../../types/global/helper';
import { Typography } from '@mui/material';
import Chip from '@mui/material/Chip';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';

export interface ICastingDirectorCardProps {
    castingDirector: ICastingDirector;
    mode?: 'search' | 'display';
    onSelectionClick?: () => void;
}

export const CastingDirectorCard: React.FC<ICastingDirectorCardProps> = ({
    castingDirector,
    onSelectionClick,
    mode = 'search',
}) => {
    const { themeStyle } = useThemeContext();

    const DisplayMode = () => {
        return (
            <Chip
                avatar={<Avatar sizes="sm" src={castingDirector.profile_picture} />}
                label={castingDirector.company_name}
                variant="outlined"
                onDelete={onSelectionClick}
                sx={{
                    width: 'fit-content',
                    '& .MuiChip-label': {
                        color: theme[themeStyle].tag_white, // or any color like '#ff0000', 'white', etc.
                    },
                    '& .MuiChip-deleteIcon': {
                        color: '#d32f2f', // delete icon color (e.g., red)
                        '&:hover': {
                            color: '#9a0007', // delete icon hover color
                        },
                    },
                }}
            />
        );
    };
    const SearchMode = () => {
        return (
            <Stack
                direction="row"
                spacing={2}
                alignItems="center"
                onClick={onSelectionClick}
                sx={{ width: '100%', minWidth: 0 }}>
                <Avatar
                    alt={castingDirector.company_name}
                    src={castingDirector.profile_picture}
                    sx={{ width: 40, height: 40, flexShrink: 0 }}
                />
                <Typography
                    sx={{
                        color: theme[themeStyle].tag_white,
                        fontFamily: FONT_ENUM.MAIN_MEDIUM,
                        fontSize: 14,
                        lineHeight: 1.3,
                        flex: 1,
                        minWidth: 0,
                    }}>
                    {castingDirector.company_name}
                </Typography>
            </Stack>
        );
    };
    return mode === 'display' ? <DisplayMode /> : <SearchMode />;
};
